import { getUsers } from '../../services/userServices';

import { validation, status } from '../../utils/constants';

const initialState = {
  fetching: false,
  error: null,
  message: null,
  status: null,
  clients: [],
  noClients: false,
}


// constants
const PREFIX = 'CLIENT';
const FETCHING = `${PREFIX}/FETCHING`;
const FETCHING_ERROR = `${PREFIX}/FETCHING_ERROR`;
const RESET_STATE = `${PREFIX}/RESET_STATE`;
const DESTROY_STATE = `${PREFIX}/DESTROY_STATE`;

const POPULATE_USERS = `${PREFIX}/POPULATE_USERS`;


// actions
const actionFetching = status => ({ type: FETCHING, payload: status });
const actionFetchingError = (error, message, status) => ({ type: FETCHING_ERROR, payload: { error, message, status } });
const actionResetState = () => ({ type: RESET_STATE });
const actionDestroyState = () => ({ type: DESTROY_STATE });

const actionPopulteUsers = payload => ({ type: POPULATE_USERS, payload });


// thunks
export const populateUsers = () => async dispatch => {
  dispatch(actionFetching());
  return getUsers()
    .then(data => {
      dispatch(actionPopulteUsers(data || []));
      dispatch(actionResetState());
      return data;
    })
}


// reducer
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCHING:
      return { ...state, fetching: true, status: action.payload || status.STATUS_FETCHING };
    case FETCHING_ERROR:
      return {
        ...state, fetching: false, status: action.payload.status || status.DEFAULT_FETCHING_ERROR,
        error: action.payload.error || validation.DEFAULT_ERROR,
        message: action.payload.message || validation.DEFAULT_ERROR_MESSAGE,
      };
    case RESET_STATE:
      return { ...state, fetching: false, status: null, error: null, message: null };

    case POPULATE_USERS:
      return { ...state, clients: action.payload || [], noClients: action.payload.leghth === 0 };
  
    default:
      return state;
  }
}
